<template>
  <admin-card title="Управление списком партнёров" :show-partners-block="false">
    <table class="table table-striped table-bordered admin-table">
      <thead>
      <tr>
        <th colspan="5" class="admin-table__controls">
          <router-link :to="{ name: 'admin.partner.add'}" class="btn btn-primary" active-class="active">
            {{ $t('add') }}
          </router-link>
        </th>
      </tr>
      <tr>
        <th>{{ $t('admin.pages.partners.fields.id') }}</th>
        <th>{{ $t('admin.pages.partners.fields.title') }}</th>
        <th>{{ $t('admin.pages.partners.fields.email') }}</th>
        <th>{{ $t('admin.pages.partners.fields.user') }}</th>
        <th>{{ $t('controls') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="partner in partners">
        <td>{{ partner.id }}</td>
        <td>{{ partner.title }}</td>
        <td>{{ partner.email }}</td>
        <td>{{ partner.user ? partner.user.name : '-' }}</td>
        <td>
          <router-link :to="{ name: 'admin.partner.edit', params: {id: partner.id} }"
                       class="btn btn-primary"
                       active-class="active">
            {{ $t('edit') }}
          </router-link>
          <button class="btn btn-warning" @click.prevent="removePartner(partner)">{{ $t('delete') }}</button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="5" class="admin-table__controls">
          <router-link :to="{ name: 'admin.partner.add'}" class="btn btn-primary" active-class="active">
            {{ $t('add') }}
          </router-link>
        </th>
      </tr>
      </tfoot>
    </table>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: this.$t('admin.pages.partners.labels.index') }
    },
    extends: AdminPage,
    computed: mapGetters({
      partners: 'partners/partners'
    }),
    methods: {
      async removePartner (partner) {
        if (confirm('Вы уверены, что хотите удалить партнёра "' + partner.title + '"?')) {
          this.$store.dispatch('partners/removePartner', { partner });
        }
      }
    },
    beforeMount () {
      this.$store.dispatch('partners/fetchPartners');
    }
  }
</script>
